import {Component, Input, OnInit} from '@angular/core';
import {DevicesService} from '../../../../services/devices.service';
import {Device} from '../../../../model/device';
import {CommandsSchema, CommandsSchemas} from '@iotsens/commands';
import {translate} from '@ngneat/transloco';
import {CommandExec} from '@iotsens/commands/src/lib/_shared/domain/command-exec.model';
import {MessageService} from 'primeng/api';
import {Response} from 'src/app/model/responses/response';

@Component({
  selector: 'app-device-commands',
  templateUrl: './device-commands.component.html',
  styleUrls: ['./device-commands.component.scss']
})
export class DeviceCommandsComponent implements OnInit {

  @Input()
  public device: Device;

  public commandsSchema: CommandsSchema[];
  public loadingSchemas: boolean;

  constructor(
    private devicesService: DevicesService,
    private messageService: MessageService
  ) {
    this.loadingSchemas = true;
  }

  ngOnInit(): void {
    this.devicesService.getDeviceCommandSchemasByUuid(this.device.uuid).subscribe((response: CommandsSchemas) => {
      this.commandsSchema = response.commandSchemas;
      this.loadingSchemas = false;
    });
  }

  executeCommand(schemaName: string, event: CommandExec): void {
    this.devicesService.executeDeviceCommand(this.device.uuid, schemaName, event.commandName, event).subscribe({
      next: (response: Response) => {
        if (JSON.parse(response.message).accepted != null) {
          const summary = translate('success.generic.changesApplied');
          const detail = translate('success.command.executed');
          this.messageService.add({ severity: 'success', summary, detail, sticky: false });
        } else {
          const summary = translate('error.summary.unexpected');
          const detail = translate('error.command.executed');
          this.messageService.add({ severity: 'error', summary, detail, sticky: false });
        }
      },
      error: error => {
        const summary = translate('error.summary.unexpected');
        const detail = translate('error.command.executed');
        this.messageService.add({ severity: 'error', summary, detail, sticky: false });
      }
    });
  }
}
